<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      v-if="hasRole('>=ADMIN')"
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="UsersAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="user in results" :key="user.id" :xl="6">
          <RecordUser :user="user" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordUser from './components/RecordUser'
import Table from '@mixins/Table'

export default {
  mixins: [Table],
  components: { RecordUser },
  data() {
    const { roles } = this.$store.getters

    return {
      paginationOptions: {
        name: 'adminUser',
        service: 'user',
        searchIn: [
          'firstName',
          'lastName',
          'email',
        ],
        tabs: [
          // TODO: use i18n
          {
            label: 'All',
            value: null,
          },
          {
            label: 'Users',
            append: 'role',
            value: 'USER',
          },
          {
            label: 'Admins',
            append: 'role',
            value: 'ADMIN',
          },
        ],
        tabsIndexes: [0],
        filters: [
          {
            label: 'Name',
            append: ['firstName', '$ilike'],
          },
          {
            label: 'Last name',
            append: ['lastName', '$ilike'],
          },
          {
            label: 'Email',
            append: value => value
              ? { email: { $like: value.toLowerCase() } }
              : {},
          },
          {
            label: 'Role',
            type: 'select',
            append: 'role',
            options: roles,
          },
          {
            label: 'Signed up date, from',
            type: 'date',
            append: ['createdAt', '$gte'],
          },
          {
            label: 'Signup date, to',
            type: 'date',
            append: ['createdAt', '$lte'],
          },
        ],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Users",
    "button": "Add a user"
  }
}
</i18n>
